import { simplePath } from "../../utils.js";
const GET_EMAIL_OPTIONS = 'v2/user-profile-settings/email-options';
function get_email_options_path() {
    return simplePath(GET_EMAIL_OPTIONS, {});
}
export { GET_EMAIL_OPTIONS, get_email_options_path };
